// src/theme.js

export const theme = {
    primaryFontColor: 'var(--Structural-Structure-8, #1F1E2C)',
    colorPrimary: 'var(--highlight-accent-secondary, #184353)',
    colorBackground: 'var(--Structural-Structure-1, #F5F1ED)',
    colorFooterText: 'var(--Structure4, #929CA8)',
    colorRequest: 'var(--Status-Info, #95CFD3)',
    colorCreateText: 'var(--Structural-Structure-4, #999)',
    colorSecondary: '#143342',
    colorBlack: 'var(--lighten-darken-dark-black, #000)',
    colorBoxBackground: '#ffffff66',
    colorMenuFont: '#789098',
    colorLogo: 'var(--lighten-darken-light-white, #FFF)',
    colorTableHeaderBackground: 'var(--Structural-Structure-2, #E1E1E1);',
    colorWhite: '#FFFFFF',
    colorButtonPrimary: 'var(--highlight-accent-primary, #FF5F39)',
    colorButtonPrimaryHover: 'var(--highlight-accent-primary-hover, #B24228)',
    colorButtonPrimaryDisable: 'var(--highlight-accent-primary-disable,rgba(255, 95, 57, 0.5))' ,
    secondaryFontColor: 'var(--Structural-Structure-6, #555)',
    tertiaryFontColor: 'var(--Structural-Structure-7, #3E3E4A)',
    colorGreen: 'var(--Status-Success, #75BD2F)',
    borderColor: 'var(--Structural-Structure-2, #E1E1E1)',
    containerWidth: 1100,
    containerPadding: 40,
    buttonSecondary: '#FCEFEC',
    border: '#E1E1E1',
    fontFamilyBold: 'Poppins-SemiBold',
    fontFamilyRegular: 'Poppins-Regular',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontWeightLight: 300,
    fontWeightNormal: 400,
    fontWeightBold: 500,
    fontWeightBolder: 700,
    maxContentWidth: '1100px',
    contentPadding: '0 75px',
};
